export default {
footer: {
    ageRestriction: "Nền tảng của chúng tôi chỉ dành cho người dùng từ 18 tuổi trở lên. Cờ bạc có thể gây nghiện. Vui lòng chơi có trách nhiệm và chỉ nhằm mục đích giải trí. Để biết thêm thông tin, hãy truy cập trang Chơi game có trách nhiệm của chúng tôi.",
    followUs: "THEO DÕI CHÚNG TÔI",
    company: "CÔNG TY",
    legal: "PHÁP LÝ",
    support: "HỖ TRỢ",
    gameProviders: "NHÀ CUNG CẤP TRÒ CHƠI",
    copyright: "Copyright © 2019-2026 LOGO. TẤT CẢ CÁC QUYỀN ĐƯỢC BẢO HỘ.",
	documents: "Tài liệu",
  }
}
